import { CopyIcon, CheckIcon } from "lucide-react";
import React, { useState } from "react";
import { CopyToClipboard as ReactCopyToClipboard } from "react-copy-to-clipboard";

interface CopyToClipboardButtonProps {
  text: string;
}

const CopyToClipboardButton: React.FC<CopyToClipboardButtonProps> = ({
  text,
}) => {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    setCopied(true);
    setTimeout(() => setCopied(false), 1500); // Revert back after 1.5 seconds
  };

  return (
    <ReactCopyToClipboard text={text} onCopy={handleCopy}>
      <button className="ml-2 text-blue-500 hover:text-blue-700">
        {copied ? <CheckIcon size={16} /> : <CopyIcon size={16} />}
      </button>
    </ReactCopyToClipboard>
  );
};

export default CopyToClipboardButton;
